export enum HoardingLightEnum {
    F_L = "FL",
    B_L = "BL",
    N_L = "NL"
}
